export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8518.fb58be7c.jpg";